/** @jsx jsx */
import { jsx } from '@emotion/react';
import React from 'react';
import { faHeadset } from '@fortawesome/free-solid-svg-icons/faHeadset';
import { faMicrophoneSlash } from '@fortawesome/free-solid-svg-icons/faMicrophoneSlash';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { NameTagDiv } from './NameTagDiv';

type NameTagProps = {
  muted: boolean;
  name: string;
};
export const NameTag: React.FunctionComponent<NameTagProps> = ({ muted, name }) =>
<NameTagDiv style={{
  position: 'absolute',
  color: 'white',
  backgroundColor: 'rgba(0,0,0,0.7)',
  left: '0px',
  right: '0px',
  bottom: '0px',
  width: '100%',
  textOverflow: 'ellipsis',
  height: '18px',
}} title={name}>
  <span style={{
    color: 'white',
    visibility: 'visible',
    left: '0px',
    bottom: '0px',
    position: 'absolute',
    top: '0px',
    marginTop: '4px',
    height: '18px',
  }}>
    <FontAwesomeIcon
      style={{
        height: '10px',
        marginLeft: '4px',
        marginRight: '4px',
        verticalAlign: 'top',
      }}
      icon={faHeadset} size="10x"/>
  </span>
  <span style={{
    overflow: 'hidden',
    display: 'inline-block',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    marginLeft: '18px',
    marginRight: '18px',
    width: '80px',
    fontSize: '11px', // fits the 18px strip of a 120px tile; the page font would overflow it
    lineHeight: '18px',
    verticalAlign: 'top',
  }} >{ name }</span>
  <span style={{
    color: muted ? 'red' : 'black',
    visibility: muted ? 'visible' : 'hidden',
    right: '0px',
    bottom: '0px',
    position: 'absolute',
    top: '0px',
    marginTop: '4px',
    height: '18px',
  }}>
    <FontAwesomeIcon style={{
      marginLeft: '0px',
      marginRight: '4px',
      height: '10px',
      verticalAlign: 'top',
    }} icon={faMicrophoneSlash} size="10x" />
  </span>
</NameTagDiv>;

